import { invoiceActionTypes } from '../actions/invoiceActions';

const InvoiceReducers = (state = { }, action) => {
  switch (action.type) {
  case invoiceActionTypes.GET_INVOICE.LOADING: {
    const { getInvoiceLoading } = action;
    return {
      ...state,
      getInvoiceLoading,
    };
  }
  case invoiceActionTypes.GET_INVOICE.SUCCESS: {
    const { invoices } = action;
    return {
      ...state,
      invoices,
    };
  }
  case invoiceActionTypes.GET_INVOICE_BY_ID.LOADING: {
    const { getInvoiceByIdLoading } = action;
    return {
      ...state,
      getInvoiceByIdLoading,
    };
  }
  case invoiceActionTypes.GET_INVOICE_BY_ID.SUCCESS: {
    const { selectedInvoice } = action;
    return {
      ...state,
      selectedInvoice,
    };
  }
  case invoiceActionTypes.CREATE_INVOICE.LOADING: {
    const { createInvoiceLoading } = action;
    return {
      ...state,
      createInvoiceLoading,
    };
  }
  case invoiceActionTypes.UPDATE_INVOICE.LOADING: {
    const { updateInvoiceLoading } = action;
    return {
      ...state,
      updateInvoiceLoading,
    };
  }
  case invoiceActionTypes.UPDATE_STATUS_INVOICE.LOADING: {
    const { updateInvoiceStatusLoading } = action;
    return {
      ...state,
      updateInvoiceStatusLoading,
    };
  }
  case invoiceActionTypes.DELETE_INVOICE.LOADING: {
    const { deleteInvoiceLoading } = action;
    return {
      ...state,
      deleteInvoiceLoading,
    };
  }
  case invoiceActionTypes.UPDATE_INVOICE_WORKFLOW_STEP.LOADING: {
    const { updateInvoiceWorkflowStepLoading } = action;
    return {
      ...state,
      updateInvoiceWorkflowStepLoading,
    };
  }
  case invoiceActionTypes.INVOICE_LINK_PAYMENT.LOADING: {
    const { linkIncomingPaymentsLoading } = action;
    return {
      ...state,
      linkIncomingPaymentsLoading,
    };
  }
  case invoiceActionTypes.INVOICE_UNLINK_PAYMENT.LOADING: {
    const { unlinkIncomingPaymentLoading } = action;
    return {
      ...state,
      unlinkIncomingPaymentLoading,
    };
  }
  case invoiceActionTypes.DOWNLOAD_INVOICE.LOADING: {
    const { downloadInvoiceLoading } = action;
    return {
      ...state,
      downloadInvoiceLoading,
    };
  }
  case invoiceActionTypes.DOWNLOAD_SHIPPING_LABELS.LOADING: {
    const { downloadShippingLabelsLoading } = action;
    return {
      ...state,
      downloadShippingLabelsLoading,
    };
  }
  case invoiceActionTypes.DOWNLOAD_INVOICE_LIST.LOADING: {
    const { downloadInvoiceListLoading } = action;
    return {
      ...state,
      downloadInvoiceListLoading,
    };
  }
  case invoiceActionTypes.CREATE_BULK_RETURNS.LOADING: {
    const { createBulkReturnsLoading } = action;
    return {
      ...state,
      createBulkReturnsLoading,
    };
  }
  case invoiceActionTypes.QUICK_UPDATE_INVOICE.LOADING: {
    const { quickUpdateInvoiceLoading } = action;
    return {
      ...state,
      quickUpdateInvoiceLoading,
    };
  }
  // issue stock for invoice
  case invoiceActionTypes.ISSUE_STOCK_FOR_INVOICE.LOADING: {
    const { issueStockForInvoiceLoading } = action;
    return {
      ...state,
      issueStockForInvoiceLoading,
    };
  }

  // revert stock for invoice
  case invoiceActionTypes.REVERT_STOCK_FOR_INVOICE.LOADING: {
    const { revertStockForInvoiceLoading } = action;
    return {
      ...state,
      revertStockForInvoiceLoading,
    };
  }

  default: {
    return state;
  }
  }
};

export default InvoiceReducers;
